import FuseScrollbars from '@fuse/core/FuseScrollbars';
import { Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import { twMerge } from 'tailwind-merge';
import { memo } from 'react';
import { APP_VERSION } from '@/version';
import NavbarPinToggleButton from 'src/components/theme-layouts/components/navbar/NavbarPinToggleButton';
import Navigation from 'src/components/theme-layouts/components/navigation/Navigation';
import UserMenu from 'src/components/theme-layouts/components/UserMenu';
import Logo from '../../../components/Logo';

const Root = styled('div')(({ theme }) => ({
	backgroundColor: 'var(--navbar-background)',
	color: theme.palette.text.primary,
	'& ::-webkit-scrollbar-thumb': {
		boxShadow: `inset 0 0 0 20px ${'rgba(255, 255, 255, 0.24)'}`,
		...theme.applyStyles('light', {
			boxShadow: `inset 0 0 0 20px ${'rgba(0, 0, 0, 0.24)'}`
		})
	},
	'& ::-webkit-scrollbar-thumb:active': {
		boxShadow: `inset 0 0 0 20px ${'rgba(255, 255, 255, 0.37)'}`,
		...theme.applyStyles('light', {
			boxShadow: `inset 0 0 0 20px ${'rgba(0, 0, 0, 0.37)'}`
		})
	}
}));

const StyledContent = styled(FuseScrollbars)(() => ({
	overscrollBehavior: 'contain',
	overflowX: 'hidden',
	overflowY: 'auto',
	WebkitOverflowScrolling: 'touch',
	backgroundRepeat: 'no-repeat',
	backgroundSize: '100% 40px, 100% 10px',
	backgroundAttachment: 'local, scroll'
}));

type NavbarStyle2ContentProps = {
	className?: string;
};

/**
 * The navbar style 2 content.
 */
function NavbarContent(props: NavbarStyle2ContentProps) {
	const { className = '' } = props;

	return (
		<Root className={twMerge('flex h-full flex-auto flex-col border-none overflow-hidden', className)}>
			<div className="navbar-header flex h-48 shrink-0 flex-row items-center justify-between px-12 md:h-76">
				<div className="logo-container">
					<Logo />
				</div>
				<NavbarPinToggleButton className="h-32 w-32 p-0 shrink-0" />
			</div>

			<StyledContent
				className="flex min-h-0 flex-1 flex-col"
				option={{ suppressScrollX: true, wheelPropagation: false }}
			>
				<Navigation layout="vertical" />
			</StyledContent>

			<Divider className='border-gray-800' />

			<div className="p-4 md:p-10 w-full">
				<UserMenu className="w-full" />
			</div>

			<div className="navbar-version pb-8 text-center text-xs text-gray-500 whitespace-nowrap">
				v{APP_VERSION}
			</div>
		</Root>
	);
}

export default memo(NavbarContent);
